module.exports = function() {
  return new Worker(__webpack_public_path__ + "572556dcc5b0e407eb86.worker.js");
};